module.exports = __webpack_public_path__ + "static/media/ch-box-1-hover.615c946d.svg";